<div class="container">
    <kendo-chart #chart [seriesColors]="seriesColors" (seriesClick)="onSeriesClick($event)">
        <kendo-chart-legend [labels]="legendLabels">
        </kendo-chart-legend>
        <kendo-chart-series>
            <kendo-chart-series-item type="pie" [data]="data" field="value" categoryField="category" [autoFit]="true">
                <kendo-chart-series-item-labels [content]="labelContent"></kendo-chart-series-item-labels>
            </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-tooltip>
            <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category"
                let-percentage="percentage">
                {{category}} - {{labelContent({value: value, format: true})}} ({{(percentage * 100).toFixed(2)}}%)
            </ng-template>
        </kendo-chart-tooltip>
    </kendo-chart>
</div>